import { gql } from "lib/apolloClient";
import { projectInfoFragment } from "./ProgressFragments";
import { projectUserFragment } from "Projects/modules/ProjectFragments";
import { academicHonestyFragment } from "ProjectDetails/routes/AcademicHonesty/modules/Fragments";

export const getStudentProjectQuery = gql`
  query getStudentProject(
    $studentId: ID!
    $projectGroupId: ID!
    $projectFieldFilters: PlannerFieldFilter
    $studentCourseFilters: UserCourseMapFilters
    $projectStudentsCollaboratorFilters: ProjectStudentsCollaboratorFilters
    $skipCourseDetails: Boolean!
  ) {
    node(id: $studentId, type: STUDENT) {
      ... on Student {
        id
        projects(filters: { projectGroupId: $projectGroupId }) {
          ...projectInfo
          academicHonesty {
            id
            isLocked
            lockingState {
              state
            }
            createdBy {
              id
            }
            description
          }
          studentCollaborators(filters: $projectStudentsCollaboratorFilters) {
            id
            academicHonesty(
              filters: { orderBy: DISPLAY_SEQUENCE, orderByDirection: ASC }
            ) {
              ...academicHonestyItem
            }
          }
          ibPYPElementRatings(
            filters: { academicCriteriaSetTypes: [PROJECT_OVERALL_PROGRESS] }
          ) {
            id
            academicCriteriaSet {
              criteriaType
              id
            }
            academicCriteriaValue {
              id
              label
              color
              abbreviation
            }
          }
        }
      }
    }
  }
  ${projectInfoFragment}
  ${academicHonestyFragment.basicDetails}
`;

export const getStudentProjectIdQuery = gql`
  query getStudentProjectId($studentId: ID!, $projectGroupId: ID!) {
    node(id: $studentId, type: STUDENT) {
      ... on Student {
        id
        projects(filters: { projectGroupId: $projectGroupId }) {
          id
        }
      }
    }
  }
`;

export const getSupervisorProjectQuery = gql`
  query getSupervisorProject(
    $staffId: ID!
    $projectGroupIds: [ID!]
    $searchText: String
    $skipCourseDetails: Boolean!
  ) {
    node(id: $staffId, type: STAFF) {
      ... on Staff {
        ...userItem
        projects(
          filters: {
            projectGroupIds: $projectGroupIds
            searchText: $searchText
          }
        ) {
          ...projectInfo
        }
      }
    }
  }
  ${projectInfoFragment}
  ${projectUserFragment.basicUser}
`;
